module.exports = __webpack_public_path__ + "static/img/2-6.fa8abac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2-6.png
// module id = gScv
// module chunks = 1